import React, { useCallback } from 'react'
import { FormikProps } from 'formik'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import { Input, TextAreaWithCharCount, Tooltip } from '@sketch/components'
import { initialValues } from './form'
import {
  Form,
  InlineFormRow,
  StyledInput,
  StyledWorkspaceLogo,
} from './ProfileDetailsStep.styles'
import { WorkspaceProfileURL } from '../../containers/WorkspaceProfileURL'

interface ProfileDetailsFormProps {
  workspace: WorkspaceMinimalFragment
  formikBag: FormikProps<typeof initialValues>
}
export const ProfileDetailsForm = ({
  workspace,
  formikBag,
}: ProfileDetailsFormProps) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    formikBag

  const workspaceLogoSrc = workspace.avatar?.small

  const handleCheckProfileURLLoading = useCallback(
    (value: boolean) => {
      setFieldValue('checkProfileURLLoading', value)
    },
    [setFieldValue]
  )

  const handleProfileURLChange = (value: string) => {
    setFieldValue('shortUrlName', value)
  }

  return (
    <Form>
      <InlineFormRow>
        <Tooltip content="Your Workspace Avatar" placement="top">
          <StyledWorkspaceLogo
            size="64px"
            workspaceName={workspace?.name}
            src={workspaceLogoSrc}
            disabled
          />
        </Tooltip>
        <Form.Field mb={0} name="text" label="Name">
          <Tooltip content="Your Workspace Name" placement="top">
            <StyledInput
              name="name"
              type="text"
              value={workspace?.name}
              readOnly
              disabled
            />
          </Tooltip>
        </Form.Field>
      </InlineFormRow>
      <WorkspaceProfileURL.Root
        shortUrl={values?.shortUrlName}
        name="shortUrlName"
        formikBag={formikBag}
      >
        {profileUrlMutationProps => {
          const { isUrlAvailable } = profileUrlMutationProps
          return (
            <div>
              <WorkspaceProfileURL.Input
                label={<>Public URL</>}
                name="shortUrlName"
                formikBag={formikBag}
                profileShortURLProps={profileUrlMutationProps}
                onChange={handleProfileURLChange}
                onMutationLoadingChange={handleCheckProfileURLLoading}
              />
              <WorkspaceProfileURL.Error
                name="shortUrlName"
                formikBag={formikBag}
                isUrlAvailable={isUrlAvailable}
              />
            </div>
          )
        }}
      </WorkspaceProfileURL.Root>
      <Form.Field
        mb={0}
        name="description"
        label="Description (optional)"
        errorText={touched.description ? errors.description : undefined}
      >
        <TextAreaWithCharCount
          name="description"
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="What tickles you, as a designer?"
          $minHeight="100px"
          $maxHeight="200px"
          $resize="vertical"
          maxLength={250}
        />
      </Form.Field>
      <Form.Field
        mb={0}
        name="text"
        label="Link (optional)"
        errorText={touched.websiteUrl ? errors.websiteUrl : undefined}
      >
        <Input
          name="websiteUrl"
          type="text"
          value={values.websiteUrl}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="https://mywebsite.com"
        />
      </Form.Field>
    </Form>
  )
}
